import { linkPrincipalPrefix } from '@tunasong/models'
import type { ACL } from '@tunasong/schemas'

const isExpired = (acl: ACL) => acl.expiresAt !== undefined && !(Date.parse(acl.expiresAt) > Date.now())

/** Live WRITE, then live READ, then anything else */
const rank = (acl: ACL) => (isExpired(acl) ? 0 : acl.permission === 'WRITE' ? 2 : acl.permission === 'READ' ? 1 : 0)

/** The first of a principal's strongest grants */
const strongestGrant = (acls: ACL[], principal: string) =>
  acls.filter(acl => acl.principal === principal).reduce((best, acl) => (rank(acl) > rank(best) ? acl : best))

/**
 * The ACLs a person-oriented access list should show: one row per principal, with their strongest grant. A share
 * keeps a song's own grant beside the folder's (GH #2277), so Ann can hold READ from the folder and WRITE on the
 * song; she can edit, and the list says so.
 *
 * `link:` principals are authorized-link credentials, not people. They are minted and
 * revoked by the access-link service and managed in the calendar link panel, which is
 * the surface that can explain what revoking one does. Filtering them here — rather
 * than at render — also keeps them out of the profile lookup that consumers derive from
 * this list, since a link principal has no profile and never will.
 */
export const visibleAcls = (acls: ACL[] = []) =>
  acls.filter(acl => !acl.principal.startsWith(linkPrincipalPrefix) && strongestGrant(acls, acl.principal) === acl)
